export default {
    setAlbum(state, album) {
        state.album = album.album;
        state.package = album.package;
        state.selected = [];

        state.validatedImages = state.album.filter(image => image.status == 'validated').length;
        state.deliveredImage = state.album.filter(image => image.status == 'delivered').length;

        let selected = state.album.filter(image => image.status == 'selected');
        for (let index = 0; index < selected.length; index++) {
            const select = selected[index];
            state.selected.push(select.id);
        }

    },
    selectImage(state, params) {
        state.selected.push(params);
    },
    unselectImage(state, imageId) {
        state.selected = state.selected.filter(image => image != imageId);
    },
}